module.exports = __webpack_public_path__ + "img/lens-150-minus-10.f15af5fe.png";